import { styled } from '@mui/material'
import Typography from '@mui/material/Typography'
import { colors } from '@theme/variables'

export const DetailsButtonWrapper = styled('button')`
  background: none;
  border: none;
  padding: 0;
`

export const ContactsOverviewCardWrapper = styled('div')<{ $isHighlighted: boolean; $singleViewMode: boolean }>`
  position: relative;
  width: 100%;
  min-width: 180px;
  max-width: 280px;
  background: ${colors.white};
  border: 1px solid ${({ $isHighlighted }) => ($isHighlighted ? colors.primary : colors.lightGrey)};
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 10px;
  display: flex;

  ${({ $singleViewMode }) =>
    `
      max-width: ${$singleViewMode ? '315px' : '280px'};
    `};
`

export const ContactsRadioWrapper = styled('div')`
  display: flex;
  align-items: center;
`

export const ContactsOverviewCardContent = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`

export const MeetingTitleContainer = styled('div')<{ $singleViewMode: boolean }>`
  display: flex;
  align-items: center;
  padding-bottom: 2px;
  gap: 4px;
  ${({ $singleViewMode }) =>
    `
      max-width: ${$singleViewMode ? '280px' : '220px'};
    `};
`

export const MeetingDateTime = styled(Typography)`
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const MeetingTitle = styled(Typography)`
  white-space: nowrap;
`

export const ContactCountsWrapper = styled('div')`
  max-width: 200px;
`

export const MeetingEventNameContainer = styled('div')`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
`

export const MeetingEventName = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 4px;
`

export const MeetingEventYear = styled(Typography)``

export const MeetingDate = styled(Typography)`
  margin-bottom: 10px;
`

export const AttendeesArrow = styled('img')<{ $back?: boolean }>`
  width: 24px;
  height: 32px;
  margin: 0 5px 0 5px;

  ${({ $back }) =>
    `
      transform: ${$back ? 'rotate(180deg)' : ''};
    `}
`

export const AttendeesContainer = styled('div')<{ $singleViewMode: boolean }>`
  display: flex;
  align-items: flex-start;
  min-height: 34px;
  padding-left: 2px;

  ${({ $singleViewMode }) =>
    `
      max-width: ${$singleViewMode ? '280px' : '215px'};
      margin-bottom: ${$singleViewMode ? '0px' : '14px'};
    `};
`

export const AttendeeInfoContainer = styled('div')<{ $disabled?: boolean }>`
  white-space: break-spaces;
  max-width: 64px;
  overflow-wrap: break-word;
  display: flex;
  flex-direction: column;
  margin-left: 4px;
  justify-content: center;

  ${({ $disabled }) =>
    `
      opacity: ${$disabled ? 0.2 : 1};
    `};
`

export const ContactStatusBar = styled('div')<{ $color?: string }>`
  width: 4px;
  flex: 0 0 auto;
  margin-right: 8px;
  ${({ $color }) =>
    `
      background: ${$color || colors.lightGrey};
    `}
`

export const MeetingStatusDot = styled('div')<{ $color?: string }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  ${({ $color }) =>
    `
      background: ${$color || colors.lightGrey};
    `}
`

export const ContactsOverviewCardLockIcon = styled('div')`
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 8px;
  right: 4px;
`
